import './bootstrap';
import '../scss/app.scss';
import '../scss/fonts.scss';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { i18nVue } from 'laravel-vue-i18n';
import { ZiggyVue } from '../../vendor/tightenco/ziggy/dist/vue.m';
import { translation } from './translation';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(
        `./Pages/${name}.vue`,
        import.meta.glob('./Pages/**/*.vue'),
    ),
    setup({
        el, App, props, plugin,
    }) {
        const app = createApp({ render: () => h(App, props) });

        app.config.globalProperties.$disableNavigation = props.initialPage.props.disableNavigation ?? false;

        app.use(plugin)
            .use(ZiggyVue)
            .mixin({ methods: { route } })
            .mixin(translation) // Vue2 simple translation
            .use(i18nVue, {
                // Vue3 advanced translations
                resolve: async (lang) => {
                    const langs = import.meta.glob('../lang/*.json');
                    return langs[`../lang/${lang}.json`]();
                },
            })
            .mount(el);
    },
    progress: {
        color: '#121927',
        showSpinner: true,
    },
});
